import { Button, Heading, Text, Box, Image } from '@chakra-ui/react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthSecondHeading } from '../../components/Auth/Headings';
import { AuthLayout } from '../../components/Layouts/Auth/AuthLayout';
import { ROUTERS } from '../../data';
import SadSmileImage from '../../assets/img/SadSmile.png';

const UserDeletedSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toLogin = () => navigate(ROUTERS.INIT);

  return (
    <AuthLayout>
      <Image src={SadSmileImage} alt='sad smile' />

      <Heading variant='bigCaption' fontSize='3xl' mt={4}>
        {t('profile.was.deleted.caption')}
      </Heading>

      <AuthSecondHeading maxWidth='500px' mt={6}>
        {t('profile.was.deleted.sub.caption')}
      </AuthSecondHeading>

      <Countdown
        date={Date.now() + 30000}
        renderer={({ seconds }) => (
          <Box color={'brand.fontColorWhite'}>
            <Text mt={4}>{t('profile.was.deleted.text', { seconds })}</Text>
          </Box>
        )}
        onComplete={toLogin}
      />

      <Button variant='linkUnderlinePrimary' size='lg' color='brand.fontColorWhite' onClick={toLogin} mt={4}>
        Log in
      </Button>
    </AuthLayout>
  );
};

export default UserDeletedSuccess;
